<div class="partner-dropdown-options" data-cy="select-in-table-partner-dropdown-menu" ngbDropdownMenu>
  @for (option of dropdownOptions; track option) {
    <div>
      <div (click)="toggleChildren(option)" class="partner-dropdown-option-wrapper partner-dropdown-label"><span
                [ngClass]="{'iwp-icon-gen_arrow_right': !option.isOpen,
                'iwp-icon-gen_arrow_down': option.isOpen}"></span><span
      [attr.data-cy]="'tree-dropdown-father-' + option.code"
    class="partner-dropdown-label father">{{option.name}}</span>
  </div>
  @if (option.children) {
    <div>
      @for (child of option.children; track child) {
        <div>
          @if (option.isOpen) {
            <div (click)="selectOption(child, option.name)"
              [attr.data-cy]="'tree-dropdown-child-' + child.code"
              class="partner-dropdown-label children text-ellipsis">
              <app-tooltip [dynamic]="true" [message]="child | prettyPrintReference">
                <span>{{child | prettyPrintReference}}</span>
              </app-tooltip>
            </div>
          }
        </div>
      }
    </div>
  }
</div>
}
</div>
